(() => {
  'use strict';
  const track = document.querySelector('.ugc-track');
  if (!track) return;
  const cards = [...track.querySelectorAll('.ugc-card')];
  const videos = [...track.querySelectorAll('video')];
  const previous = document.querySelector('.ugc-prev');
  const next = document.querySelector('.ugc-next');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function updateArrows() {
    const end = Math.max(0, track.scrollWidth - track.clientWidth);
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= end - 2;
  }
  function scrollTo(left) {
    track.scrollTo({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  }
  function step(direction) {
    const distance = cards.length > 1
      ? cards[1].offsetLeft - cards[0].offsetLeft
      : track.clientWidth;
    scrollTo(track.scrollLeft + direction * distance);
  }
  previous.addEventListener('click', () => step(-1));
  next.addEventListener('click', () => step(1));
  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  track.addEventListener('keydown', event => {
    // Leave the video's native keyboard controls alone.
    if (event.target !== track) return;
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    if (event.key === 'ArrowLeft') step(-1);
    if (event.key === 'ArrowRight') step(1);
    if (event.key === 'Home') scrollTo(0);
    if (event.key === 'End') scrollTo(track.scrollWidth - track.clientWidth);
  });

  cards.forEach(card => {
    const video = card.querySelector('video');
    const play = card.querySelector('.ugc-play');
    play.addEventListener('click', () => {
      if (video.ended) video.currentTime = 0;
      video.play().catch(error => {
        if (error.name === 'AbortError') return;
        // Native controls remain available if the browser declines playback.
        play.hidden = true;
      });
    });
    video.addEventListener('play', () => {
      videos.forEach(other => { if (other !== video) other.pause(); });
      if (document.activeElement === play) video.focus();
      play.hidden = true;
    });
    video.addEventListener('pause', () => { play.hidden = false; });
    video.addEventListener('ended', () => { play.hidden = false; });
  });

  // Stop sound when a clip leaves the page or the horizontal row.
  if ('IntersectionObserver' in window) {
    const visibility = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio < 0.35) entry.target.pause();
      });
    }, { threshold: [0, 0.35] });
    videos.forEach(video => visibility.observe(video));
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videos.forEach(video => video.pause());
  });
  updateArrows();
})();
